import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

import { EstimateTypeView } from '@api-proxies';
import { EstimateTypeService } from '@http/clients/estimate-type.service';
import { ReportsService } from '@services/reports.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-estimate-type-editor',
    templateUrl: './estimate-type-editor.component.html',
    styleUrls: ['./estimate-type-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class EstimateTypeEditorComponent extends EditorComponentBase<number | null> implements OnInit, OnDestroy {
    estimateTypes?: EstimateTypeView[];
    selectedEstimateType?: EstimateTypeView;
    subscription?: Subscription;

    constructor(
        private readonly estimateTypeService: EstimateTypeService,
        private reportsService: ReportsService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.estimateTypes = await this.estimateTypeService.getAwardableEstimateTypes();

        if (this.bindingProperty !== null) {
            if (this.additionalInfo?.application === 'reporting') {
                this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
                    if (ready) {
                        this.selectedEstimateType = this.foundItem();
                    }
                });
            } else {
                this.selectedEstimateType = this.foundItem();
            }
        }
    }

    foundItem() {
        return this.estimateTypes?.find((x) => x.id === this.bindingProperty);
    }

    onEstimateTypeChange() {
        this.bindingProperty = this.selectedEstimateType?.id ?? null;
        this.valueChange.emit();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
